<div class="mapa-breadcrumb-container">
    <p-breadcrumb [home]="home" [model]="items" [styleClass]="'mapa-breadcrumb'"></p-breadcrumb>
    <p-progressBar [styleClass]="loadingRouteConfig ? 'mapa-loading' : 'mapa-loading-hidden'"
                   mode="indeterminate"></p-progressBar>
</div>
